export const GET_SECTION_ROLES = "GET_SECTION_ROLES";
export const GET_SECTION_ROLE_BY_ID = "GET_SECTION_ROLE_BY_ID";
export const UPDATE_SECTION_ROLE = "UPDATE_SECTION_ROLE";
export const DELETE_SECTION_ROLE = "DELETE_SECTION_ROLE";
export const CREATE_SECTION_ROLE = "CREATE_SECTION_ROLE";
